import React from 'react';

const CustomRow = ({
  alignItems = 'center',
  color = 'inherit',
  justifyContent = 'space-between',
  margin = '0',
  padding = '0',
  width = '100%',
  children
}) => {
  return (
    <div style={{ alignItems, color, display: 'flex', justifyContent, margin, padding, width }}>
      {children}
    </div>
  );
};

export default CustomRow;
